/* angular stuff */
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

/* 3rd party libraries */

/* our own stuff */
import { AuthGuard } from "./core/guards/auth.guard";
import { NotFoundComponent } from "./core/not-found/not-found.component";
import { LanguageResolver } from "./core/services/language-resolver";

const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  {
    path: "",
    loadChildren: () =>
      import("src/app/features/auth/auth.module").then((m) => m.AuthModule),
  },
  // { path: 'CommonListModule', loadChildren: ()=> import('src/app/shared/modules/modals/common-list/common-list.module').then(m=>m.CommonListModule) },
  // { path: 'CommonListModule', loadChildren: './app/list/list.module#CommonListModule' } ,
  {
    path: "home",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/main/main.module").then((m) => m.MainModule),
    data: { title: "Pridebook Pro" },
  },
  {
    path: "activity",
    loadChildren: () =>
      import("src/app/features/activity-log/activity-log.module").then(
        (m) => m.ActivityLogModule
      ),
  },
  {
    path: "ac",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/ac/ac.module").then((m) => m.AcModule),
    data: { title: "General Ledger" },
  },
  {
    path: "hr",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/hr/hr.module").then((m) => m.HrModule),
    data: { title: "Human Capital Management" },
  },
  {
    path: "ps",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/in/in.module").then((m) => m.InModule),
    data: { title: "Purchese Module" },
  },
  {
    path: "pm",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/pm/pm.module").then((m) => m.PmModule),
    data: { title: "Project Management" },
  },
  {
    path: "bm",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/bm/bm.module").then((m) => m.BmModule),
    data: { title: "Project Management" },
  },
  {
    path: "vm",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/vm/vm.module").then((m) => m.VmModule),
    data: { title: "Vehicle Management" },
  },
  {
    path: "zz",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/zz/zz.module").then((m) => m.ZzModule),
    data: { title: "Application Development" },
  },
  {
    path: "ap",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/ap/ap.module").then((m) => m.ApModule),
    data: { title: "Application Development" },
  },

  {
    path: "in",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/in/in.module").then((m) => m.InModule),
    data: { title: "Material Management" },
  },

  {
    path: "sa",
    resolve: { Items: LanguageResolver },
    loadChildren: () =>
      import("src/app/features/sa/sa.module").then((m) => m.SaModule),
    data: { title: "Systems & Settings" },
  },
  {
    path: "sl",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/sl/sl.module").then((m) => m.SlModule),
    data: { title: "Sales" },
  },
  {
    path: "load",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/misc/misc.module").then((m) => m.MiscModule),
    data: { title: "Load" },
  },
  {
    path: "ba",
    resolve: { Items: LanguageResolver },
    loadChildren: () =>
      import("src/app/features/ba/ba.module").then((m) => m.BaModule),
    data: { title: "Business Analytics" },
  },
  {
    path: "bi",
    resolve: { Items: LanguageResolver },
    loadChildren: () =>
      import("src/app/features/bi/bi.module").then((m) => m.BiModule),
    data: { title: "Synergy Analytics (SA)" },
  },

  {
    path: "pr",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/pr/pr.module").then((m) => m.PrModule),
    data: { title: "Textiles Process Management" },
  },
  {
    path: "fa",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/fa/fa.module").then((m) => m.FaModule),
    data: { title: "Fixed Asset" },
  },
  {
    path: "ph",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/ph/ph.module").then((m) => m.PhModule),
    data: { title: "Pharmaceutical Production" },
  },
  {
    path: "sm",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/sm/sm.module").then((m) => m.SmModule),
    data: { title: "Service Maintenance Management" },
  },

  {
    path: "sg",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/sg/sg.module").then((m) => m.SgModule),
    data: { title: "Security Guard Management" },
  },
  {
    path: "vi",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/vi/vi.module").then((m) => m.ViModule),
    data: { title: "Visitor Management" },
  },
  {
    path: "gp",
    resolve: { Items: LanguageResolver },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/features/gp/gp.module").then((m) => m.GpModule),
    data: { title: "E-Gate Pass Management" },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
